import * as React from 'react'
import { ThemeProvider } from '@emotion/react'
import { Box, Button, Container, IconButton, Snackbar, Alert } from '@mui/material'
import MUIDataTable from 'mui-datatables'
import theme from '../theme'
import api from '../services/api'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import FormDialog from './FormDialog'
import { useAuth } from '../auth/AuthProvider'
import { useNavigate } from 'react-router-dom'

export default function () {
    const navigate = useNavigate()
    const auth = useAuth()
    const [handlerDialog, setHandlerDialog] = React.useState(false)
    const [update, setUpdate] = React.useState(false)
    const [id, setId] = React.useState()
    const [data, setData] = React.useState()
    const [snack, setSnack] = React.useState({ open: false, message: '', severity: 'success' })

    React.useEffect(() => {
        setUpdate(false)
        updateData()
    }, [handlerDialog, update])

    React.useEffect(() => {
        document.title = "Horus - SOC APIs"
    }, [])

    const columns = [
        {
            name: 'id',
            label: 'Id',
            options: { display: false }
        },
        {
            name: 'cod_empresa',
            label: "Empresa",
            options: { filter: true, sort: true }
        },
        {
            name: 'url',
            label: "URL",
            options: { filter: false, sort: false }
        },
        {
            name: 'auth_type',
            label: "Tipo Auth",
            options: {
                filter: true,
                sort: false,
                customBodyRender: value => {
                    const labels = { none: 'Nenhuma', basic: 'Basic', apikey: 'API Key' }
                    return <span>{labels[value] || value}</span>
                }
            }
        },
        {
            name: 'min_level',
            label: "Min Level",
            options: { filter: false, sort: true }
        },
        {
            name: 'resolve_timeout',
            label: "Timeout Resolve",
            options: {
                filter: false,
                sort: false,
                customBodyRender: value => <span>{value ? `${value}min` : '-'}</span>
            }
        },
        {
            name: 'active',
            label: "Ativo",
            options: {
                customBodyRender: value => <span>{value ? "Ativo" : 'Inativo'}</span>,
                filter: true,
                sort: true,
            }
        },
        {
            name: "actions",
            label: "Acoes",
            options: {
                customBodyRenderLite: (dataIndex) => {
                    const item = data[dataIndex]
                    if (!item) return null
                    return (
                        <>
                            <Button
                                disabled={!auth.hasPerm('api_zabbix.edit')}
                                sx={{ color: theme.palette.text.primary }}
                                onClick={() => {
                                    setId(item.id)
                                    setHandlerDialog(true)
                                }}
                            >
                                <EditIcon />
                            </Button>
                            <Button
                                disabled={!auth.hasPerm('api_zabbix.delete')}
                                sx={{ color: theme.palette.text.primary }}
                                onClick={() => deleteItem(item.id, item.cod_empresa)}
                            >
                                <DeleteIcon />
                            </Button>
                            <Button
                                disabled={!auth.hasPerm('api_zabbix.edit')}
                                sx={{ color: theme.palette.text.primary }}
                                onClick={() => testConnection(item.id)}
                            >
                                <PlayArrowIcon />
                            </Button>
                        </>
                    )
                }
            }
        }
    ]

    const deleteItem = (id, name) => {
        const conf = confirm(`Deseja realmente apagar a config ${name}?`)
        if (!conf) return
        api.delete(`api_wazuh_es/delete/${id}/`).then(() => {
            setUpdate(true)
            setSnack({ open: true, message: 'Config removida com sucesso.', severity: 'success' })
        }).catch(() => setSnack({ open: true, message: 'Erro ao remover config.', severity: 'error' }))
    }

    const testConnection = (id) => {
        setSnack({ open: true, message: 'Testando conexao...', severity: 'info' })
        api.post(`api_wazuh_es/test/${id}`).then(res => {
            setSnack({ open: true, message: res.data?.message || 'Conexao OK!', severity: 'success' })
        }).catch(err => {
            setSnack({ open: true, message: err.response?.data?.detail || 'Erro ao testar conexao.', severity: 'error' })
        })
    }

    const updateData = () => {
        api.get('api_wazuh_es/all')
            .then(res => setData(res.data))
            .catch((err) => {
                if (err.response?.status == 401) {
                    navigate('/401')
                }
                setData()
            })
    }

    const showFormDialog = () => {
        setId()
        setHandlerDialog(true)
    }

    const options = {
        filterType: 'checkbox',
        rowsPerPageOptions: [30, 50, 100],
        rowsPerPage: 30,
        rowHover: false,
        print: false,
        selectableRows: 'none',
        download: false,
        customToolbar: () => (
            <IconButton
                disabled={!auth.hasPerm('api_zabbix.create')}
                onClick={showFormDialog}
                sx={{ color: theme.palette.text.primary }}
            >
                <AddIcon />
            </IconButton>
        ),
        customToolbarSelect: () => { },
    }

    return (
        <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
            <ThemeProvider theme={theme}>
                <FormDialog open={handlerDialog} id={id} handlerClose={() => setHandlerDialog(false)} updateData={updateData} />
                <Snackbar
                    open={snack.open}
                    autoHideDuration={6000}
                    onClose={() => setSnack(s => ({ ...s, open: false }))}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert onClose={() => setSnack(s => ({ ...s, open: false }))} severity={snack.severity} sx={{ width: '100%' }}>
                        {snack.message}
                    </Alert>
                </Snackbar>
                <Box sm={12} lg={12}>
                    <MUIDataTable
                        title={"SOC APIs (Wazuh / Elasticsearch)"}
                        data={data}
                        columns={columns}
                        options={options}
                    />
                </Box>
            </ThemeProvider>
        </Container>
    )
}
